import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
import Levels from './models/Levels';
import ExpLogs from './models/ExpLogs';
export default [new Extend.Model(User).attribute('expLevel').attribute('expPercent').attribute('expTotal').attribute('expNext').attribute('expNextNeed'), new Extend.Store().add('levels', Levels).add('exp-logs', ExpLogs)];